<template>
<div class="chapter">
<div class="inner_page">
<h1 id="toc">OUR JOURNEY</h1>
<div class="img"><img alt="" src="images/p5.jpg"/></div>
<p class="toc0"><a href="#/xhtml/p5"><b>PREFACE </b></a></p>
<p class="toc0"><a href="#/xhtml/p6">1. <b>REWILDING </b></a></p>
<p class="toc0"><span href="#/xhtml/p7" title="Link target outside of Sample">2. <b>LAKOTA LANDS </b></span></p>
<p class="toc0"><span href="#/xhtml/p8" title="Link target outside of Sample">3. <b>RESCUE ME </b></span></p>
<p class="toc0"><span href="#/xhtml/p9" title="Link target outside of Sample">4. <b>LUCY </b></span></p>
<p class="toc0"><span href="#/xhtml/p10" title="Link target outside of Sample">5. <b>HOOVES ON FIRST </b></span></p>
<p class="toc0"><span href="#/xhtml/p11" title="Link target outside of Sample">6. <b>GIN RUMMY AND LEMON MOISTURIZER </b></span></p>
<p class="toc0"><span href="#/xhtml/p12" title="Link target outside of Sample">7. <b>AWAKENINGS </b></span></p>
<p class="toc0"><span href="#/xhtml/p13" title="Link target outside of Sample">8. <b>MOSES BRINGS PLENTY </b></span></p>
<p class="toc0"><span href="#/xhtml/p14" title="Link target outside of Sample">9. <b>IT TAKES A VILLAGE—OR A CONGRESSMAN </b></span></p>
<p class="toc0"><span href="#/xhtml/p15" title="Link target outside of Sample">10. <b>MORNING JOE </b></span></p>
<p class="toc0"><span href="#/xhtml/p16" title="Link target outside of Sample">11. <b>CAMBRIDGE </b></span></p>
<p class="toc0"><span href="#/xhtml/p17" title="Link target outside of Sample">12. <b>SERENDIPITY </b></span></p>
<p class="toc0"><span href="#/xhtml/p18" title="Link target outside of Sample">13. <b>BORN TO REWILD </b></span></p>
<p class="toc0"><span href="#/xhtml/p19" title="Link target outside of Sample">14. <b>WHAT NOW? </b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p4.vue?9b9835b0